module.exports = __webpack_public_path__ + "static/media/VectorResendCode.ad6c937c.svg";